import Vue from 'vue'
import App from './App.vue'

import appNpmTools from "app-npm-tools-v2"
// import "app-npm-tools-v2/app-npm-tools-v2.css"


Vue.config.productionTip = false;

Vue.use(appNpmTools);

new Vue({
  render: h => h(App),
}).$mount('#app')
